import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMarkupTriangle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.2434 17.6513L10.586 5.67095C11.0446 4.80456 11.274 4.37136 11.5799 4.22973C11.8464 4.10637 12.1536 4.10637 12.4201 4.22973C12.7261 4.37136 12.9554 4.80456 13.4141 5.67094L19.7566 17.6513C20.1669 18.4263 20.3721 18.8138 20.3306 19.13C20.2944 19.4059 20.1449 19.6543 19.9179 19.8154C19.658 19.9999 19.2195 19.9999 18.3426 19.9999H5.65746C4.78053 19.9999 4.34207 19.9999 4.08207 19.8154C3.85514 19.6543 3.7056 19.4059 3.66941 19.13C3.62794 18.8138 3.8331 18.4263 4.2434 17.6513Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgMarkupTriangle;
